
<template>
  <div> 
    <v-dialog :value="dialog" scrollable persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Editando conta do funcionário</span>
        </v-card-title>
        <v-card-text>
          <v-col cols='12'>
            <div v-if="totalAccounts != null" v-for="(account, index) in new_employee?.accounts_attributes?.data" :key="index">
              <BankAccountForm only_cpf :account="account?.attributes"></BankAccountForm>
              <v-divider></v-divider>
            </div>
            <div class="d-flex justify-center mt-2">
              <v-btn text color="primary" v-if="totalAccounts < 2" @click="totalAccounts += 1">
                <v-icon left>mdi-plus</v-icon>
                Adicionar conta
              </v-btn>
              <v-btn text color="error" v-if="totalAccounts == 2 && !cannot_remove" @click="totalAccounts -= 1">
                <v-icon left>mdi-minus</v-icon>
                Remover conta
              </v-btn>
            </div>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn cancel @click="closeDialog"></f-btn>
          <f-btn save @click="emitUpdate"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import validations from "@/mixins/validations.js"
export default {
  name: 'EmployeeEditAccountDialog',
  mixins: [ validations ],
  props: {
    employee:{
      type: Object,
      default: () => { return {} },
    },
    change_dialog:{
      type: Boolean,
      default: false,
    }
  },
  components: {
    BankAccountForm: () => import("@/_backoffice/_registrations/components/shared/forms/BankAccountForm.vue"),
  },
  data() {
    return {
      new_employee:{
        id: null
      },
      dialog: false,
      totalAccounts: null,
      cannot_remove: false,
    }
  },
  methods: {
    emitUpdate(){
      this.prepareAccountEmployee()
      this.$emit('update', this.new_employee)
    },
    closeDialog(){
      this.$emit('close')
    },
    prepareAccountEmployee() {
      this?.new_employee?.accounts_attributes?.data?.forEach(el => {
        this.new_employee.update_accounts_attributes.push(el?.attributes)
      })
      if (this?.new_employee.accounts_attributes?.data?.length < 2) {
        this.new_employee.update_accounts_attributes.push(this.new_employee.new_accounts_attributes)
      }
    },
  },
  watch:{
    change_dialog(nv, old){
      this.dialog = nv
    },
    dialog(nv) {
      if (nv) {
        if (this?.employee?.data?.attributes?.accounts != null) {
          this.new_employee = {
            id: this?.employee?.data?.attributes?.id,
            accounts_attributes: this?.employee?.data?.attributes?.accounts,
            update_accounts_attributes: [],
          }
          this.totalAccounts = this.new_employee?.accounts_attributes?.data?.length || 0
          if(this.totalAccounts == 2){
            this.cannot_remove = true
          }
        }
      }
    },
    totalAccounts(nv,old){
      if(nv > old && old != null){
        this.new_employee?.accounts_attributes?.data.push({
          attributes:{
            bank_id: null,
            number: null,
            comment: null,
            agency: null,
            name: null,
            CPF: null,
            CNPJ: '000111',
            current_account: true,
          }
        })
      }else if(old != null){
        this.new_employee?.accounts_attributes?.data.pop()
      }
    }

  }
}
</script>